exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".span-placeholder[data-v-4d19eb86]{position:absolute;top:45px;left:20px;font-size:16px;color:#999}.form-extras[data-v-4d19eb86]{font-family:Rubik;font-weight:500;color:#999;font-size:18px;line-height:22px;text-align:center}.form-extras a[data-v-4d19eb86]{color:#999;display:block;text-decoration:underline;margin-bottom:15px}.input-field[data-v-4d19eb86]{border-width:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d19eb86","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/TeachersForm/Login.vue
// module id = 374
// module chunks = 0